const cleanKey = (name) => {
    if (name.startsWith('?'))
        return name.substring(1);
    return name;
};
const qs = {
    parse: (locationSearch = '') => {
        const params = (locationSearch || '').split('&');
        return params
            .map((param) => {
            const paramParts = param.split('=');
            const keyValue = {};
            if (!paramParts.length || paramParts.length > 2)
                return keyValue;
            const key = cleanKey(paramParts[0]);
            if (paramParts.length === 1 && key) {
                keyValue[key] = '';
            }
            else if (key) {
                try {
                    keyValue[key] = decodeURIComponent(paramParts[1]);
                }
                catch (err) {
                }
            }
            return keyValue;
        })
            .reduce((p, c) => Object.assign(p, c), {});
    },
};
export { qs };
